import { BimModelVersion } from "./bim-model-version.interface";


export class CreateBimModelVersionDto {
  objectId: string;
  fileUrn: string;
  sourceUrn: string;
  rootFile: string;
  zipFile: string;
  status: string;
  modelType: string;
  thumbnailFile: string;
  manifestFile: string;
  disabled: boolean;
  externalId: string;
  taskId: string;

  constructor(bimModelVersion: BimModelVersion) {
    this.objectId = bimModelVersion?.objectId;
    this.fileUrn = bimModelVersion?.fileUrn;
    this.sourceUrn = bimModelVersion?.sourceUrn;
    this.rootFile = bimModelVersion?.rootFile;
    this.zipFile = bimModelVersion?.zipFile;
    this.status = bimModelVersion?.status;
    this.modelType = bimModelVersion?.modelType;
    this.thumbnailFile = bimModelVersion?.thumbnailFile;
    this.manifestFile = bimModelVersion?.manifestFile;
    this.disabled = bimModelVersion?.disabled;
    this.externalId = bimModelVersion?.externalId;
    this.taskId = this.taskId;
  }
}

export class UpdateBimModelVersionDto {
  objectId: string;
  fileUrn: string;
  sourceUrn: string;
  rootFile: string;
  zipFile: string;
  status: string;
  modelType: string;
  thumbnailFile: string;
  manifestFile: string;
  disabled: boolean;
  active: boolean;
  externalId: string;
  taskId: string;

  constructor(bimModelVersion: BimModelVersion) {
    this.objectId = bimModelVersion.objectId;
    this.fileUrn = bimModelVersion.fileUrn;
    this.sourceUrn = bimModelVersion.sourceUrn;
    this.rootFile = bimModelVersion.rootFile;
    this.zipFile = bimModelVersion.zipFile;
    this.status = bimModelVersion.status;
    this.modelType = bimModelVersion.modelType;
    this.thumbnailFile = bimModelVersion.thumbnailFile;
    this.manifestFile = bimModelVersion.manifestFile;
    this.disabled = bimModelVersion.disabled;
    this.active = bimModelVersion.active;
    this.externalId = bimModelVersion.externalId;
    this.taskId = bimModelVersion.taskId;
  }
}
